module.exports = __webpack_public_path__ + "img/fleche1-responsive.92f65cef.svg";